import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box, IconChevronUp, IconChevronDown, Divider, mediaBreakpointMixin, IconButton } from "@zillow/constellation";
import React__default from "react";
import styled from "styled-components";
import { GROUP_WIDTH_MAP } from "../../mixins/components/GroupMixin.esm.js";
import SearchBox from "./SearchBox.esm.js";
const StyledDivider = styled(Divider).withConfig({
  displayName: "B2BSubnav__StyledDivider",
  componentId: "sc-mir6ll-0"
})(["@media ", "{display:none;}"], mediaBreakpointMixin("lg_lte"));
const StyledDropdownButton = styled(IconButton).withConfig({
  displayName: "B2BSubnav__StyledDropdownButton",
  componentId: "sc-mir6ll-1"
})(["margin-top:2px;@media ", "{display:none;}"], mediaBreakpointMixin("xl_gte"));
const SubnavLink = ({
  url,
  title,
  home
}) => {
  const commonStyles = {
    textDecoration: "none",
    fontWeight: home ? "$fontWeights.bold" : "$fontWeights.body",
    fontSize: "$fontSizes.bodySmall",
    fontFamily: "$fonts.sansSerif",
    color: home ? "$colors.textDark" : "$colors.textMedium"
  };
  if (!url || url.trim() === "") {
    return /* @__PURE__ */ jsx(Box, { sx: {
      ...commonStyles,
      cursor: "default"
    }, children: title });
  }
  return /* @__PURE__ */ jsx(Box, { as: "a", href: url, sx: {
    ...commonStyles,
    ":hover": {
      textDecoration: "underline",
      color: "$colors.blue500"
    }
  }, children: title });
};
const B2BSubnav = ({
  primaryItem,
  items = [],
  searchPrefix,
  searchPlaceholder
}) => {
  const [isOpen, setIsOpen] = React__default.useState(false);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { "data-testid": "b2b-subnav", sx: {
      borderBottom: "1px solid $colors.borderLight"
    }, children: /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "58px",
      position: "relative",
      padding: "0 $spacing.sm",
      maxWidth: GROUP_WIDTH_MAP.xl,
      margin: "0 auto"
    }, children: [
      /* @__PURE__ */ jsxs(Box, { sx: {
        display: "flex",
        alignItems: "stretch",
        "@media $lg_lte": {
          alignItems: "center"
        }
      }, children: [
        primaryItem && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(SubnavLink, { url: primaryItem.url, title: primaryItem.title, home: true }),
          /* @__PURE__ */ jsx(StyledDivider, { orientation: "vertical", marginX: "md" })
        ] }),
        /* @__PURE__ */ jsx(StyledDropdownButton, { buttonType: "tertiary", bare: true, size: "xs", "aria-expanded": isOpen ? "true" : "false", icon: isOpen ? /* @__PURE__ */ jsx(IconChevronUp, {}) : /* @__PURE__ */ jsx(IconChevronDown, {}), title: "Open menu", onClick: () => setIsOpen(!isOpen) }),
        /* @__PURE__ */ jsx(Box, { sx: {
          display: "flex",
          alignItems: "center",
          gap: "$spacing.lg",
          "@media $lg_lte": {
            display: "none"
          }
        }, children: items.map((item) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(SubnavLink, { url: item.url, title: item.title }) }, item.id)) })
      ] }),
      searchPrefix && /* @__PURE__ */ jsx(SearchBox, { placeholder: searchPlaceholder ? searchPlaceholder : "Search", actionPrefix: searchPrefix })
    ] }) }),
    /* @__PURE__ */ jsx(Box, { sx: {
      display: isOpen ? "block" : "none",
      alignItems: "center",
      gap: "$spacing.lg",
      backgroundColor: "$colors.backgroundLight",
      "@media $xl_gte": {
        display: "none"
      },
      padding: "$spacing.md $spacing.sm",
      borderBottom: "1px solid $colors.borderLight",
      boxShadow: "$shadows.shadow200",
      borderRadius: "0 0 $radii.lg $radii.lg"
    }, children: items.map((item) => /* @__PURE__ */ jsx(Box, { sx: {
      marginBottom: "$spacing.md",
      ":last-child": {
        marginBottom: 0
      }
    }, children: /* @__PURE__ */ jsx(SubnavLink, { url: item.url, title: item.title }) }, item.id)) })
  ] });
};
export {
  B2BSubnav as default
};
